module.exports = __webpack_public_path__ + "static/media/2001_maleRate_femaleRate.fe9f5f08.png";